import React from 'react';
import { bool, string } from 'prop-types';
import css from './MessageMeta.css';
import MessageStatus from './MessageStatus';
import { formatDateToString } from '../../../util/dates';
import {
    useMessageContext,
    CONTROLS_PANEL_ATTR,
    isRelatedTargetInsideControlsPanel,
} from './useMessageContext';
import { SecondaryButton } from '../../Button/Button';
import { IconCopyL, IconTrashL, IconCheckmarkStrongL } from '../../../icons';
import { useSelector } from 'react-redux';

const MessageMeta = () => {
    const deleteMessageError = useSelector(s => s['InboxPage']?.deleteMessageError);

    const {
        copied,
        copyToClickBoard,
        isOwnMessage,
        messageIsViewedByOtherParty,
        message,
        controlsPanelOpen,
        deleteMessageAllowed,
        handleMessageDeleting,
        isPendingToDeleteMessage,
        setControlsVisibility,
    } = useMessageContext();
    const { attributes } = message || {};
    const { content, createdAt } = attributes || {};

    const messageDateClass = isOwnMessage ? css.ownMessageDate : css.messageDate;

    const showError = deleteMessageError && isPendingToDeleteMessage;

    if (showError) {
        return (
            <div className={messageDateClass}>
                {deleteMessageError && isPendingToDeleteMessage && (
                    <div className={css.errorContainer}>
                        <p className={css.error}>
                            {typeof deleteMessageError === 'string'
                                ? deleteMessageError
                                : deleteMessageError?.message}
                        </p>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={messageDateClass}>
            <section className={css.metaInfo}>
                {isOwnMessage && (
                    <React.Fragment>
                        <MessageStatus messageIsViewedByOtherParty={messageIsViewedByOtherParty} />{' '}
                    </React.Fragment>
                )}
                <p>{formatDateToString(createdAt)} Uhr</p>
            </section>
            {controlsPanelOpen && (
                <aside
                    className={css.controlsPanel}
                    {...{ [CONTROLS_PANEL_ATTR]: 'true' }}
                    onBlur={event => {
                        if (isRelatedTargetInsideControlsPanel(event)) {
                            return;
                        }
                        setControlsVisibility(false);
                    }}
                    tabIndex={0}
                    role="region"
                >
                    <SecondaryButton
                        onFocus={() => setControlsVisibility(true)}
                        onClick={e => {
                            e && e.stopPropagation();
                            copyToClickBoard(content);
                        }}
                    >
                        {copied ? <IconCheckmarkStrongL /> : <IconCopyL />}
                    </SecondaryButton>
                    {deleteMessageAllowed && (
                        <SecondaryButton
                            onFocus={() => setControlsVisibility(true)}
                            onClick={e => {
                                e && e.stopPropagation();
                                handleMessageDeleting();
                            }}
                        >
                            <IconTrashL />
                        </SecondaryButton>
                    )}
                </aside>
            )}
        </div>
    );
};

MessageMeta.propTypes = {
    isOwnMessage: bool,
    messageIsViewedByOtherParty: bool,
    createdAt: string,
    className: string,
};

export default MessageMeta;
